module.exports = __webpack_public_path__ + "static/media/DimensionConversion_002.fd346aa0.png";